// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum AlertType {
	Unknown = 0,
	DeviceOffline = 1,
	RadarDown = 2,
	NoRadarFrames = 3,
	NoTargets = 4,
	VideoPipelineDown = 5,
	HardwareModuleError = 6,
	PortForwardingDown = 7,
	StreamingServiceDown = 8,
	ModemServiceMissing = 9,
	LowTargetFusionRate = 10,
	HighRamUsage = 11,
	DiskSpaceLow = 12,
	WebRelayUnreachable = 13,
	WebRelayModelMismatch = 14,
}

export const AlertTypeDisplayNames: { [key in keyof typeof AlertType]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"DeviceOffline": "Device Offline",
	1 : "Device Offline",
	"RadarDown": "Radar Down",
	2 : "Radar Down",
	"NoRadarFrames": "No Radar Frames",
	3 : "No Radar Frames",
	"NoTargets": "No Targets Detected",
	4 : "No Targets Detected",
	"VideoPipelineDown": "Video Pipeline Down",
	5 : "Video Pipeline Down",
	"HardwareModuleError": "Hardware Module Error",
	6 : "Hardware Module Error",
	"PortForwardingDown": "Port Forwarding Down",
	7 : "Port Forwarding Down",
	"StreamingServiceDown": "Streaming Service Down",
	8 : "Streaming Service Down",
	"ModemServiceMissing": "Modem Service Missing",
	9 : "Modem Service Missing",
	"LowTargetFusionRate": "Low Target Fusion Rate",
	10 : "Low Target Fusion Rate",
	"HighRamUsage": "High RAM Usage",
	11 : "High RAM Usage",
	"DiskSpaceLow": "Low Disk Space",
	12 : "Low Disk Space",
	"WebRelayUnreachable": "Relay Board Unreachable",
	13 : "Relay Board Unreachable",
	"WebRelayModelMismatch": "Relay Board Model Mismatch",
	14 : "Relay Board Model Mismatch",
}

export const getAlertTypeDisplayName = (key: AlertType | (keyof typeof AlertType & string)) => {
	return AlertTypeDisplayNames[key];
}

